<app-page-heading [key]="(mode === DisplayMode.Creation ? 'user-dashboard.subcontractors.form.page-title.creation' : 'user-dashboard.subcontractors.form.page-title.edition')"
                  [subheadingIcon]="'fa fa-truck'"></app-page-heading>

<section class="container">
    <div class="row">
        <div class="col-xs-12">
            <div class="row">
                <div class="col-xs-8">
                    <button type="button" class="btn btn-primary btn-outline btn-lg pull-left" (click)="location.back()">
                        <span class="fa fa-arrow-left"> </span>
                    </button>
                </div>
                <div class="col-xs-4 text-right" *ngIf="mode == DisplayMode.Edition">
                    <app-dropdown-button [btnTextKey]="'user-dashboard.subcontractors.form.actions.label'">
                        <li app-dropdown-button-item (click)="openDeleteConfirm(deleteModal)">
                            <i class="fa fa-trash-alt m-r-xxs"></i>
                            <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.form.actions.delete'}]"></span>
                        </li>
                    </app-dropdown-button>
                </div>
            </div>

            <br>

            <div class="ibox float-e-margins">
                <div class="ibox-content border-primary">

                    <form #subcontractorForm="ngForm" (submit)="processForm()" novalidate class="row" *ngIf="carrier">
                        <fieldset [disabled]="formProcessingBlocked || carrier.blocked" class="col-xs-12">

                            <div class="form-group">
                                <label class="control-label" for="carrier-name" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.form.carrier.label'}]"></label>
                                <input class="form-control input-lg m-b" name="carrier-name" id="carrier-name"
                                       [(ngModel)]="carrier.name" readonly>
                                <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.form.carrier.help'}]"></small>
                            </div>

                            <div class="form-group">
                                <label class="control-label" for="subcontractor-name" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.form.name.label'}]"></label>
                                <input class="form-control input-lg" name="subcontractor-name" id="subcontractor-name" type="text" required
                                       [(ngModel)]="subcontractor.name">
                                <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.form.name.help'}]"></small>
                            </div>

                            <div class="form-group m-b-md">
                                <label class="control-label" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.form.region.label'}]"></label>
                                <div class="radio">
                                    <label for="region-is-eu">
                                        <input type="radio" [value]="true" id="region-is-eu" [name]="'is-eu'" [(ngModel)]="subcontractor.isEu">
                                        <i class="fa radio-icon"></i>
                                        <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.form.region.eu'}]"></span>
                                    </label>
                                    <label for="region-is-others">
                                        <input type="radio" [value]="false" id="region-is-others" [name]="'is-eu'" [(ngModel)]="subcontractor.isEu">
                                        <i class="fa radio-icon"></i>
                                        <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.form.region.others'}]"></span>
                                    </label>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="control-label" for="subcontractor-address" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.form.address.label'}]"></label>
                                <input class="form-control input-lg" name="subcontractor-address" id="subcontractor-address" type="text"
                                       [(ngModel)]="subcontractor.address" [required]="subcontractor.isEu">
                                <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.form.address.help'}]"></small>
                            </div>

                            <div class="form-group">
                                <label class="control-label" for="subcontractor-vat-code" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.form.vat-code.label'}]"></label>
                                <input class="form-control input-lg" name="subcontractor-vat-code" id="subcontractor-vat-code" type="text"
                                       [(ngModel)]="subcontractor.vatCode" [required]="subcontractor.isEu">
                                <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.form.vat-code.help'}]"></small>
                            </div>

                            <div class="form-group">
                                <label class="control-label" for="subcontractor-load-group" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.form.load-group.label'}]"></label>
                                <input class="form-control input-lg" name="subcontractor-load-group" id="subcontractor-load-group" type="text"
                                       [(ngModel)]="subcontractor.loadGroup">
                                <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.form.load-group.help'}]"></small>
                            </div>

                            <div class="form-group">
                                <label class="control-label" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.form.tms-type.label'}]"></label>

                                <ng-container [ngSwitch]="carrier.tmsType">
                                    <input *ngSwitchCase="TmsType.BLUJAY" class="form-control input-lg m-b" name="carrier-tms-type"
                                           [i18n]="[{target: 'attribute:value', key: 'user-dashboard.tms-type.blujay'}]" readonly>
                                    <input *ngSwitchCase="TmsType.LOCAL" class="form-control input-lg m-b" name="carrier-tms-type"
                                           [i18n]="[{target: 'attribute:value', key: 'user-dashboard.tms-type.local'}]" readonly>
                                    <input *ngSwitchDefault class="form-control input-lg m-b" name="carrier-tms-type"
                                           [(ngModel)]="carrier.tmsType" readonly>
                                </ng-container>

                                <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.form.tms-type.help'}]"></small>
                            </div>

                            <ng-container class="form-group" *ngIf="carrier.tmsType === TmsType.BLUJAY">
                                <div class="form-group">
                                    <label class="control-label" for="carrier-blujay-url" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.form.blujay-url.label'}]"></label>
                                    <div class="input-group">
                                        <div class="input-group-addon"><i class="fa fa-link"></i></div>
                                        <input class="form-control input-lg" name="carrier-blujay-url" id="carrier-blujay-url"
                                                [(ngModel)]="carrier.blujayUrl" readonly>
                                    </div>
                                    <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.form.blujay-url.help'}]"></small>
                                </div>

                                <div class="form-group m-t-lg">
                                    <app-switcher [(ngModel)]="useCustomBlujayCredentials" name="use-blujay-credentials" (change)="useCustomBlujayCredentialsChange()"
                                                  [labelKey]="'user-dashboard.subcontractors.form.custom-blujay-credentials.label'"></app-switcher>
                                </div>

                                <ng-container *ngIf="useCustomBlujayCredentials">
                                    <div class="form-group">
                                        <label class="control-label" for="blujayUsername" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.form.blujay-username.label'}]"></label>
                                        <div class="input-group">
                                            <div class="input-group-addon"><i class="fa fa-user"></i></div>
                                            <input name="blujayUsername" type="text" class="form-control input-lg" id="blujayUsername" required
                                                   [(ngModel)]="subcontractor.blujayCredentials.username" (change)="trimBlujayUsername()"
                                                   aria-describedby="blujayUsernameHelp">
                                        </div>
                                        <small id="blujayUsernameHelp" class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.form.blujay-username.help'}]"></small>
                                    </div>

                                    <div class="form-group">
                                        <label class="control-label" for="blujayApiToken" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.form.blujay-api-token.label'}]"></label>
                                        <div class="input-group">
                                            <div class="input-group-addon"><i class="fa fa-key"></i></div>
                                            <input name="blujayApiToken" type="text" class="form-control input-lg" id="blujayApiToken" required
                                                   [(ngModel)]="subcontractor.blujayCredentials.apiToken" (change)="trimBlujayApiToken()"
                                                   aria-describedby="blujayApiTokenHelp">
                                        </div>
                                        <small id="blujayApiTokenHelp" class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.form.blujay-api-token.help'}]"></small>
                                    </div>
                                </ng-container>
                            </ng-container>


                            <div class="form-buttons pull-right">
                                <button type="submit" class="btn btn-primary btn-lg"
                                        [disabled]="subcontractorForm.invalid || subcontractorForm.pristine">
                                    <span class="fa fa-save space-right-5"></span>
                                    <span [i18n]="[{target: 'innerHTML', key: (mode == DisplayMode.Creation ? 'user-dashboard.subcontractors.form.buttons.create' :
                                          'user-dashboard.carriers.form.buttons.update')}]"></span>
                                </button>
                            </div>
                        </fieldset>
                    </form>

                </div>
            </div>
        </div>
    </div>
</section>


<ng-template #deleteModal let-c="close" let-d="dismiss">
    <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.form.modals.delete.content'}]"></span>
</ng-template>
